import React, { ReactNode } from 'react';

const ListSeparator = <ItemType extends Object>({
  items,
  renderItem,
  resolveKey,
  separator = ',',
  endSeparator = '&',
}: ListSeparatorProps<ItemType>) => {
  return (
    <>
      {items.map((item, index) => {
        const key = resolveKey(item);
        const isLastItem = index === items.length - 1;
        const isFirstItem = index === 0;
        const sep = isLastItem ? ` ${endSeparator}` : separator;
        return (
          <React.Fragment key={key}>
            {!isFirstItem && <>{sep}&nbsp;</>}
            {renderItem(item)}
          </React.Fragment>
        );
      })}
    </>
  );
};

export interface ListSeparatorProps<ItemType> {
  separator?: ReactNode;
  endSeparator?: ReactNode;
  items: ItemType[];
  renderItem: (item: ItemType) => ReactNode;
  resolveKey: (item: ItemType) => React.Key;
}

export default ListSeparator;
